import React from "react";
import {
  Button,
  ButtonGroup,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from "@mui/material";
import { ArrowDropDown } from "@mui/icons-material";

export const BaseButtonGroup = ({
  actions = [],
  disabled = false,
  handleSelectedAction = () => {},
}) => {
  const anchorRef = React.useRef(null);

  const [open, setOpen] = React.useState(false);
  const [actionIndex, setActionIndex] = React.useState(0);

  const activeAction = actions[actionIndex];

  // methods
  const handleMenuItemClick = (_, index) => {
    setActionIndex(index);
    setOpen(false);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) return;
    setOpen(false);
  };

  return (
    <>
      <ButtonGroup
        ref={anchorRef}
        variant={
          activeAction?.variant ||
          (actionIndex === 0 ? "contained" : "outlined")
        }
        color={activeAction?.color}
        aria-label="split button"
        disabled={disabled}
      >
        <Button
          startIcon={activeAction?.icon ?? null}
          disabled={activeAction?.isDisabled}
          onClick={() => handleSelectedAction(actionIndex)}
        >
          {activeAction?.label}
        </Button>

        <Button
          size="small"
          aria-controls={open ? "split-button-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-label="select visa status action"
          aria-haspopup="menu"
          onClick={() => setOpen((prev) => !prev)}
          disabled={Object.keys(actions)?.every(
            (act) => actions[act]?.isDisabled
          )}
        >
          <ArrowDropDown />
        </Button>
      </ButtonGroup>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        style={{ zIndex: 12 }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {actions.map((action, index) => (
                    <MenuItem
                      key={action?.label}
                      selected={index === actionIndex}
                      disabled={action.isDisabled}
                      onClick={(e) => handleMenuItemClick(e, index)}
                    >
                      {action?.label}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};
